import { ShopSearchParams } from '../../types';

export const PRICE_INCREMENT = 10;

export const getSearchPriceRange = (
  msrp: ShopSearchParams['msrp'],
): { min: number | undefined; max: number | undefined } => {
  if (typeof msrp === 'number') return { min: msrp, max: msrp };
  if (typeof msrp === 'object' && msrp !== null) {
    return {
      min: msrp.$gte ?? msrp.$gt,
      max: msrp.$lte ?? msrp.$lt,
    };
  }
  return { min: undefined, max: undefined };
};

export const getInitialPriceRange = (
  msrp: ShopSearchParams['msrp'],
  globalMin: number,
  globalMax: number,
): [number, number] => {
  const { min, max } = getSearchPriceRange(msrp);
  const roundedMin = Math.floor((min ?? globalMin) / PRICE_INCREMENT) * PRICE_INCREMENT;
  const roundedMax = Math.ceil((max ?? globalMax) / PRICE_INCREMENT) * PRICE_INCREMENT;
  return [roundedMin, roundedMax];
};
